import React, { useState } from 'react';
import { 
  Building, 
  ShieldCheck, 
  Upload, 
  FileCheck2, 
  EyeOff, 
  Download,
  Info
} from 'lucide-react';

export const RentalShieldPage: React.FC = () => {
  const [agencyName, setAgencyName] = useState('Ray White Real Estate');
  const [propertyAddress, setPropertyAddress] = useState('Unit 12, 45 Crown St, Wollongong NSW 2500');
  const [redactTfn, setRedactTfn] = useState(true);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-950 text-teal-300 text-xs font-bold border border-teal-800">
          <Building className="w-3.5 h-3.5" />
          <span>AUSTRALIAN TENANCY APPLICATION SHIELD</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Rental Application Document Packager</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Protect your 100-point identity documents when applying for rental properties. Automatically apply agency-specific watermarks and black out Tax File Numbers.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-xl text-xs">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-1">
            <label className="block font-bold text-slate-300">Real Estate Agency Name:</label>
            <input
              type="text"
              value={agencyName}
              onChange={(e) => setAgencyName(e.target.value)}
              className="w-full px-3 py-2.5 rounded-xl bg-slate-950 border border-slate-700 text-white"
            />
          </div>
          <div className="space-y-1">
            <label className="block font-bold text-slate-300">Property Address Being Applied For:</label>
            <input
              type="text"
              value={propertyAddress}
              onChange={(e) => setPropertyAddress(e.target.value)}
              className="w-full px-3 py-2.5 rounded-xl bg-slate-950 border border-slate-700 text-white"
            />
          </div>
        </div>

        <label className="flex items-center gap-2.5 p-4 rounded-xl bg-slate-950 border border-slate-800 cursor-pointer">
          <input
            type="checkbox"
            checked={redactTfn}
            onChange={(e) => setRedactTfn(e.target.checked)}
            className="rounded accent-emerald-500"
          />
          <div>
            <span className="font-bold text-white">Auto-Redact Tax File Numbers (TFNs) on Payslips</span>
            <p className="text-slate-400 text-[11px]">Real estate property managers have no legal authority to collect or store your TFN.</p>
          </div>
        </label>

        <div className="p-4 rounded-2xl bg-teal-950/30 border border-teal-800 text-teal-200">
          <span className="font-bold block mb-1">Generated Protective Stamp:</span>
          <p className="font-mono text-[11px]">
            "COPY — FOR TENANCY APPLICATION AT {agencyName.toUpperCase()} ({propertyAddress}) ONLY — {new Date().toLocaleDateString('en-AU')}"
          </p>
        </div>
      </div>
    </div>
  );
};
